<script>
import Accordion from '@/components/Accordion/Main';
import AccordionItem from '@/components/Accordion/Item';

export default {
  props: {},
  components: {
    Accordion,
    AccordionItem,
  },
};
document.querySelector('#app').classList.add('overflow-hidden');
</script>

<template>
  <div class="section section_gray section_indents">
    <div class="container">
      <div class="flex flex-col lg:flex-row">
        <div class="w-full lg:w-2/3 xl:w-3/4 mr-5">
          <h2 class="title-h2 mb-6">Ответы на популярные вопросы</h2>
          <accordion>
            <accordion-item>
              <template #accordion-trigger>
                <p class="text-gray-600">Как выбрать новый автомобиль?</p>
              </template>

              <template #accordion-content>
                <p class="text-gray-600">
                  Наши специалисты помогут вам подобрать модель, учитывая ваш
                  бюджет, предпочтения и потребности.
                </p>
              </template>
            </accordion-item>

            <accordion-item>
              <template #accordion-trigger>
                <p class="text-gray-600">Какие авто доступны в автосалоне?</p>
              </template>

              <template #accordion-content>
                <p class="text-gray-600">
                  Мы предлагаем широкий ассортимент автомобилей от брендов LADA,
                  GEELY, XCITE, Changan, Belgee и KNEWSTAR.
                </p>
              </template>
            </accordion-item>

            <accordion-item>
              <template #accordion-trigger>
                <p class="text-gray-600">Как дёшево купить новый автомобиль?</p>
              </template>

              <template #accordion-content>
                <p class="text-gray-600">
                  Воспользуйтесь нашими акциями, скидками или системой Trade-In
                  для получения выгодных условий.
                </p>
              </template>
            </accordion-item>
            <accordion-item>
              <template #accordion-trigger>
                <p class="text-gray-600">
                  Можно ли купить новый авто в кредит?
                </p>
              </template>

              <template #accordion-content>
                <p class="text-gray-600">
                  Да, мы предлагаем удобные условия кредитования на все
                  представленные модели.
                </p>
              </template>
            </accordion-item>
            <accordion-item>
              <template #accordion-trigger>
                <p class="text-gray-600">Что входит в стоимость автомобиля?</p>
              </template>

              <template #accordion-content>
                <p class="text-gray-600">
                  Стоимость включает все опции автомобиля согласно выбранной
                  комплектации, заводскую гарантию и набор документов для
                  регистрации.
                </p>
              </template>
            </accordion-item>
            <accordion-item>
              <template #accordion-trigger>
                <p class="text-gray-600">
                  Какие дополнительные услуги вы предоставляете?
                </p>
              </template>

              <template #accordion-content>
                <p class="text-gray-600">
                  Выгодное кредитования, страхование, гарантийное обслуживание,
                  помощь в регистрации и организация тест-драйвов.
                </p>
              </template>
            </accordion-item>
            <accordion-item>
              <template #accordion-trigger>
                <p class="text-gray-600">Как работает Trade-In?</p>
              </template>

              <template #accordion-content>
                <p class="text-gray-600">
                  В автоцентре на месте оценивается ваш старый автомобиль, и его
                  стоимость идет в счет оплаты нового.
                </p>
              </template>
            </accordion-item>
            <accordion-item>
              <template #accordion-trigger>
                <p class="text-gray-600">
                  Где купить новый автомобиль в Санкт-Петербурге?
                </p>
              </template>

              <template #accordion-content>
                <p class="text-gray-600">
                  Вы можете приобрести авто в нашем салоне или заказать
                  отдельной услугой доставку автомобиля до ближайшего к вам
                  салона Прагматики..
                </p>
              </template>
            </accordion-item>
          </accordion>
        </div>
      </div>
    </div>
  </div>
</template>
